import { formatDate } from '@/helpers/formatDate'
import { TRatingItems } from '@/Types/types';
import { Avatar, Badge, Box, Divider, Flex, HStack, Text } from '@chakra-ui/react'
import Image from 'next/image';
import { useEffect, useState } from 'react'

export default function UserRatings({ breedRating }: any) {
  const [totalRatings, setTotalRatings] = useState<number>(0)
  const [ratingItems, setRatingItems] = useState<TRatingItems[]>([]);

  const categoryMapping: { [key: string]: string } = {
    "Vive em apartamento": "liveInApartment",
    "Apego com o dono": "attachedToTheOwner",
    "Tendência de latir": "barkTendency",
    "Facilidade para adestrar": "easeToTrain",
    "Convívio com crianças": "socializingWithChildren",
    "Convívio com outros animais": "coexistenceWithOtherAnimals",
    "Queda de pelos": "hairLoss",
  };

  useEffect(() => {
    if (breedRating) {
      setTotalRatings(breedRating.meta.pagination.total)
    }
    setRatingItems([
      {
        icon: "/images/rating/icon1.svg",
        name: "Vive em apartamento",
      },
      {
        icon: "/images/rating/icon2.svg",
        name: "Apego com o dono",
      },
      {
        icon: "/images/rating/icon3.svg",
        name: "Tendência de latir",
      },
      {
        icon: "/images/rating/icon4.svg",
        name: "Facilidade para adestrar",
      },
      {
        icon: "/images/rating/icon5.svg",
        name: "Convívio com crianças",
      },
      {
        icon: "/images/rating/icon6.svg",
        name: "Convívio com outros animais",
      },
      {
        icon: "/images/rating/icon7.svg",
        name: "Queda de pelos",
      },
    ])
  }, [breedRating])

  return (
    <Flex
      p={{ base: "16px", lg: "0 32px 32px 32px" }}
      direction="column"
      gap="12px"
      id='opinions'
    >
      <Text
        fontSize="16px"
        lineHeight="24px"
        fontWeight="500"
        color="purple.600"
      >
        {totalRatings} {totalRatings > 1 ? "avaliações" : "avaliação"}
      </Text>
      <Flex direction="column" gap="16px" mt="32px">
        {totalRatings > 0 &&
          breedRating.data.map((rating: any) => (
            <Flex
              key={rating.id}
              border="1px solid #E2E8F0"
              borderRadius="6px"
              gap="32px"
              padding="20px"
              direction="column"
            >
              <Box>
                <Flex gap="12px" alignItems="center">
                  <Avatar
                    size="md"
                    name={rating.attributes.name}
                    src={rating.attributes.avatar}
                  />
                  <Flex direction="column" gap="4px">
                    <Text
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="500"
                      color="gray.800"
                    >
                      {rating.attributes.name}
                    </Text>
                    <Text
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                      color="gray.600"
                    >
                      {formatDate(rating.attributes.createdAt)}
                    </Text>
                  </Flex>
                </Flex>
                <Divider orientation="horizontal" mt="16px" />
              </Box>
              <Flex direction="column" gap="24px">
                <Text
                  fontSize="18px"
                  lineHeight="28px"
                  fontWeight="700"
                  color="gray.800"
                >
                  Depoimento
                </Text>
                <Text
                  fontSize="16px"
                  lineHeight="24px"
                  color="gray.600"
                >
                  "{rating.attributes.description}"
                </Text>
              </Flex>
              <Flex flexWrap="wrap" gap="16px" alignItems="center">
                {ratingItems.map((item: TRatingItems, i: number) => (
                  <Flex key={item.name} width="332px" justifyContent="space-between" alignItems="center">
                    <HStack>
                      <Image src={item.icon} alt={item.name} width={24} height={24} />
                      <Text
                        fontSize={{ base: "14px", lg: "16px" }}
                        lineHeight={{ base: "20px", lg: "24px" }}
                        color="gray.500"
                        ml="8px"
                      >
                        {item.name}
                      </Text>
                    </HStack>
                    <Flex
                      alignItems="baseline"
                      bgColor='gray.50'
                      borderRadius='50px'
                      padding='0 10px'
                    >
                      <Text
                        fontSize="16px"
                        lineHeight="24px"
                        fontWeight="600"
                        color="gray.700"
                      >
                        {rating.attributes.rating[categoryMapping[item.name]]}
                      </Text>
                      <Text
                        fontSize="12px"
                        lineHeight="16px"
                        color="gray.500"
                      >
                        /5
                      </Text>
                    </Flex>

                  </Flex>
                ))}
              </Flex>
            </Flex>
          ))
        }
      </Flex>
    </Flex>
  )
}
